<dx-popup
	[(visible)]="visible"
	[showTitle]="true"
	[showCloseButton]="true"
	[dragEnabled]="false"
	[hideOnOutsideClick]="false"
	[width]="'calc(100vw - 40px)'"
	[maxWidth]="1380"
	[height]="'calc(100vh - 40px)'"
	[maxHeight]="840"
	title="Invoice PDF delivery"
	(onHiding)="close()">
	<section class="pdf-deliveries">
		<header class="pdf-deliveries__hero">
			<div>
				<span class="pdf-deliveries__eyebrow">Delivery recovery</span>
				<h2>Outstanding invoice PDFs</h2>
				<p>Review invoice PDF attachments waiting to be transferred to the target system, retry failures in bulk, or stop deliveries that should no longer run.</p>
			</div>
			<div class="run-status" [ngClass]="latestRunClass">
				<span>Latest run</span>
				<strong>{{ latestRunLabel }}</strong>
				<small *ngIf="runStatus?.executeAtUtc">Scheduled {{ runStatus?.executeAtUtc | date:'dd/MM/yyyy HH:mm' }}</small>
			</div>
		</header>

		<div class="pdf-deliveries__metrics">
			<div class="metric-card">
				<span>Outstanding</span>
				<strong>{{ deliveries.length }}</strong>
			</div>
			<div class="metric-card metric-card--failed">
				<span>Failed before</span>
				<strong>{{ failedCount }}</strong>
			</div>
			<div class="metric-card metric-card--processing">
				<span>Processing</span>
				<strong>{{ processingCount }}</strong>
			</div>
			<div class="pdf-deliveries__toolbar">
				<button class="btn btn-sm btn-primary" [disabled]="selectedDeliveryIds.length === 0 || bulkActionRunning || loading" (click)="retrySelected()">
					<i class="far fa-redo"></i>
					Retry selected
					<span *ngIf="selectedDeliveryIds.length > 0" class="selection-count">{{ selectedDeliveryIds.length }}</span>
				</button>
				<button class="btn btn-sm btn-outline-primary" [disabled]="deliveries.length === 0 || bulkActionRunning || loading" (click)="retryAll()">
					<i class="far fa-layer-group"></i>
					Retry all
				</button>
				<button class="btn btn-sm btn-outline-secondary" [disabled]="loading || bulkActionRunning" (click)="refresh()" aria-label="Refresh invoice PDF deliveries">
					<i class="far fa-sync" [class.fa-spin]="loading"></i>
					Refresh
				</button>
			</div>
		</div>

		<div *ngIf="loading && deliveries.length === 0" class="pdf-deliveries__message" role="status" aria-live="polite">
			<i class="far fa-spinner-third fa-spin"></i>
			<span>Loading outstanding deliveries...</span>
		</div>
		<div *ngIf="!loading && deliveries.length === 0" class="pdf-deliveries__message pdf-deliveries__message--empty" role="status" aria-live="polite">
			<i class="far fa-check-circle"></i>
			<strong>Everything is delivered</strong>
			<span>There are no outstanding invoice PDF attachments.</span>
		</div>

		<dx-data-grid
			*ngIf="deliveries.length > 0"
			[dataSource]="deliveries"
			[selectedRowKeys]="selectedDeliveryIds"
			[showBorders]="false"
			[showRowLines]="true"
			[showColumnLines]="false"
			[rowAlternationEnabled]="true"
			[hoverStateEnabled]="true"
			[allowColumnResizing]="true"
			[columnAutoWidth]="true"
			[wordWrapEnabled]="true"
			(onSelectionChanged)="onSelectionChanged($event)"
			keyExpr="id"
			height="calc(100vh - 430px)">
			<dxo-search-panel [visible]="true" [width]="280" placeholder="Search outstanding deliveries..."></dxo-search-panel>
			<dxo-selection mode="multiple" showCheckBoxesMode="always" selectAllMode="allPages"></dxo-selection>
			<dxo-scrolling mode="standard" showScrollbar="always"></dxo-scrolling>
			<dxo-paging [pageSize]="25"></dxo-paging>
			<dxo-pager [showInfo]="true" [showNavigationButtons]="true" [showPageSizeSelector]="true" [allowedPageSizes]="[25, 50, 100]"></dxo-pager>

			<dxi-column dataField="sourceInvoiceId" caption="Source invoice" width="125"></dxi-column>
			<dxi-column dataField="subject" caption="Document" minWidth="190"></dxi-column>
			<dxi-column dataField="status" caption="Status" cellTemplate="statusCellTemplate" width="125"></dxi-column>
			<dxi-column dataField="attemptCount" caption="Attempts" dataType="number" alignment="center" width="90"></dxi-column>
			<dxi-column dataField="creationDateUtc" caption="Queued" dataType="datetime" format="dd/MM/yyyy HH:mm" width="145"></dxi-column>
			<dxi-column dataField="nextAttemptAtUtc" caption="Next attempt" dataType="datetime" format="dd/MM/yyyy HH:mm" width="145"></dxi-column>
			<dxi-column dataField="lastError" caption="Last error" minWidth="230"></dxi-column>
			<dxi-column caption="Actions" cellTemplate="actionsCellTemplate" [allowFiltering]="false" [allowSorting]="false" [fixed]="true" fixedPosition="right" width="160"></dxi-column>

			<div *dxTemplate="let cell of 'statusCellTemplate'">
				<span class="delivery-status" [ngClass]="'delivery-status--' + cell.data.status.toLowerCase()">{{ cell.data.status }}</span>
			</div>

			<div class="pdf-deliveries__actions" *dxTemplate="let cell of 'actionsCellTemplate'">
				<button class="action-icon action-icon--retry" title="Retry now" aria-label="Retry this PDF delivery now" [disabled]="!cell.data.canRetry || isActionRunning(cell.data.id)" (click)="retry(cell.data)">
					<i class="far fa-redo"></i>
				</button>
				<button class="action-icon action-icon--cancel" title="Cancel delivery" aria-label="Cancel this PDF delivery" [disabled]="!cell.data.canCancel || isActionRunning(cell.data.id)" (click)="cancel(cell.data)">
					<i class="far fa-times"></i>
				</button>
			</div>
		</dx-data-grid>
	</section>
</dx-popup>
